import { useApiQuery, useApiMutation } from '~/hooks';
import type { MutationOptions } from '@tanstack/react-query';
import {
  getConnectedAccountsApi,
  getActiveSessionsApi,
  setup2FAApi,
} from '../repository';

export const SECURITY_QUERY_KEYS = {
  CONNECTED_ACCOUNTS: 'connected-accounts',
  ACTIVE_SESSIONS: 'active-sessions',
};

/**
 * Query hook to fetch connected accounts
 * @returns React Query result with connected accounts
 */
export const useGetConnectedAccountsQuery = () => {
  return useApiQuery({
    queryKey: [SECURITY_QUERY_KEYS.CONNECTED_ACCOUNTS],
    queryFn: () => getConnectedAccountsApi(),
  });
};

/**
 * Query hook to fetch active sessions
 * @returns React Query result with active sessions
 */
export const useGetActiveSessionsQuery = () => {
  return useApiQuery({
    queryKey: [SECURITY_QUERY_KEYS.ACTIVE_SESSIONS],
    queryFn: () => getActiveSessionsApi(),
  });
};

/**
 * Mutation hook for setting up 2FA (generates secret and QR code)
 * Note: This is a mutation because it modifies server state
 */
export const useSetup2FAMutation = (
  options?: MutationOptions<
    Awaited<ReturnType<typeof setup2FAApi>>,
    CustomAxiosError,
    void
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: () => setup2FAApi(),
    onSuccess: (...rest) => {
      options?.onSuccess?.(...rest);
    },
  });
};
